

export const judgeStrIncludes = (parentStr,str)=>{
    return !!parentStr.includes(str);
}